import { render } from "./BookFile.vue?vue&type=template&id=737cac94&scoped=true"
import script from "./BookFile.vue?vue&type=script&lang=js"
export * from "./BookFile.vue?vue&type=script&lang=js"

import "./BookFile.vue?vue&type=style&index=0&id=737cac94&scoped=true&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-737cac94"]])

export default __exports__